module.exports = __webpack_public_path__ + "static/media/cigar.fad1e661.svg";